export default (temp, isCelsius = true) => {
  const min = isCelsius ? 32 : 89.6
  const max = isCelsius ? 45 : 113
  return temp && (temp >= min && temp <= max) ? parseFloat(temp.toFixed(1)) : null
}
